import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import { getDaysRemainingFromSeconds, ONE_HOUR_IN_SECONDS, } from '../utils/get-days-remaining-from-seconds';
export const FormattedPollTime = ({ secondsLeft, isClosed, openDays, }) => {
    if (isClosed)
        return _jsx(FormattedMessage, { id: "POLLS_TIME_ENDED" });
    if (secondsLeft && secondsLeft < ONE_HOUR_IN_SECONDS)
        return _jsx(FormattedMessage, { id: "POLLS_TIME_LAST_MINUTES" });
    const days = secondsLeft
        ? getDaysRemainingFromSeconds(secondsLeft)
        : openDays;
    if (days === 0)
        return _jsx(FormattedMessage, { id: "POLLS_TIME_REMAINING_DAYS_WEB.zero" });
    if (days === 1)
        return _jsx(FormattedMessage, { id: "POLLS_TIME_REMAINING_DAYS_WEB.one" });
    return (_jsx(FormattedMessage, { id: "POLLS_TIME_REMAINING_DAYS_WEB.other", values: { days } }));
};
//# sourceMappingURL=formatted-poll-time.js.map